import { customTv } from "#utils";

import type { VariantProps } from "tailwind-variants";

const dividerStyles = customTv({
  base: "border-0 border-solid",
  variants: {
    orientation: {
      horizontal: "w-full",
      vertical: "h-full",
    },
    size: {
      s: "",
      l: "",
      xl: "",
    },
    variant: {
      normal: "border-outline-decorative",
      decorative: "border-outline-brand rounded-xs",
    },
  },
  compoundVariants: [
    // Horizontal dividers
    {
      orientation: "horizontal",
      size: "s",
      class: "h-px border-t",
    },
    {
      orientation: "horizontal",
      size: "l",
      class: "h-0.5 border-t-2",
    },
    {
      orientation: "horizontal",
      size: "xl",
      class: "h-1 border-t-4",
    },
    // Vertical dividers
    {
      orientation: "vertical",
      size: "s",
      class: "w-px border-l",
    },
    {
      orientation: "vertical",
      size: "l",
      class: "w-0.5 border-l-2",
    },
    {
      orientation: "vertical",
      size: "xl",
      class: "w-1 border-l-4",
    },
  ],
  defaultVariants: {
    orientation: "horizontal",
    size: "s",
    variant: "normal",
  },
});

export interface DividerProps extends VariantProps<typeof dividerStyles> {
  className?: string;
  variant?: "normal" | "decorative";
}

export function Divider({
  orientation = "horizontal",
  size = "s",
  className,
  variant = "normal",
}: DividerProps) {
  return (
    <hr
      className={dividerStyles({
        orientation,
        size,
        variant,
        class: className,
      })}
    />
  );
}
